/* eslint-disable */
import { observable, action } from 'mobx'
import axios from 'axios'

import Auth from './Auth'

import config from '../config'

console.log(config)
class Template {
  @observable files = []
  template = 'motd'

  @action
  getFileList = () => {
    return axios({
      method: 'get',
      url: `${config.api_uri}/html/motd/dir?theme=${this.template}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    })
      .then(res => {
        this.files = res.data.data.map(file => ({
          title: file,
          path: `/${file}`,
          content: null
        }))
      })
      .catch(err => console.warn(err))
  }

  @action
  getFileContent(path) {
    return axios({
      method: 'get',
      url: `${config.api_uri}/html/motd/file?theme=${
        this.template
      }&path=${path}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      }
    }).then(res => {
      this.files = this.files.toJS().reduce((acc, file, index) => {
        if (file.path === path) {
          file.content = res.data.data
        }

        return [...acc, file]
      }, [])

      return res.data.data
    })
  }

  @action
  putFile(path, content) {
    return axios({
      method: `put`,
      url: `${config.api_uri}/html/motd/file?theme=${
        this.template
      }&path=${path}`,
      headers: {
        'x-auth-access-token': Auth.token.accessToken
      },
      data: { content }
    }).then(res => res.data)
  }
}

export default new Template()



// WEBPACK FOOTER //
// ./src/stores/Template.js